import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Route } from 'react-router-dom';
import Users from '../pages/Users';
import Groups from '../pages/Groups';
import Buckets from '../pages/Buckets';
import BucketMetrics from '../pages/BucketMetrics';
import AccountMetrics from '../pages/AccountMetrics';
import Policies from '../pages/Policies';
import Sidebar from './Sidebar';
import PageFooter from './PageFooter';

import brandingStyles from '../branding/brandingStyles';

class AppComponent extends Component {

    render() {
        return (
            <div id="wrapper" style={brandingStyles.backgrounds.menu}>
                <Sidebar/>
                  <Route
                    path={this.props.match.url}
                    exact
                    component={Users}
                  />
                  <Route
                    path={`${this.props.match.url}/groups`}
                    exact
                    component={Groups}
                  />
                  <Route
                    path={`${this.props.match.url}/groups/:selected`}
                    component={Groups}
                  />
                  <Route
                    path={`${this.props.match.url}/account-metrics`}
                    exact
                    component={AccountMetrics}
                  />
                  <Route
                    path={`${this.props.match.url}/buckets`}
                    exact
                    component={Buckets}
                  />
                  <Route
                    path={`${this.props.match.url}/buckets/:name`}
                    exact
                    component={BucketMetrics}
                  />
                  <Route
                    path={`${this.props.match.url}/policies`}
                    exact
                    component={Policies}
                  />
                <PageFooter/>
            </div>
        );
    }
}

AppComponent.propTypes = {
    match: PropTypes.object,
};

export default AppComponent;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/